import { observable, computed, action, decorate } from 'mobx';
var store = {
  steps: [],
  stepPoints: [],
  defaultPoints: 10,
  currentStepIndex: 0,
  dictionary: {
    Quiz: {
      correct: 'Correct!',
      incorrect: 'Sorry. Incorrect!',
      learnMore: 'Learn more',
      yourScore: 'Your score'
    }
  },
  get nextStepIndex() {
    return this.currentStepIndex < this.steps.length - 1 ? this.currentStepIndex + 1 : null;
  },
  get currentStep() {
    return this.steps[this.currentStepIndex];
  },
  get points() {
    return this.stepPoints.length ? this.stepPoints.reduce(function (total, points) {
      return total + points;
    }) : 0;
  },
  gotoStep: function gotoStep(stepIndex) {
    this.currentStepIndex = stepIndex;
  },
  getDictionary: function getDictionary() {
    var dictionary = {
      Quiz: {
        correct: 'Correct!',
        incorrect: 'Sorry. Incorrect!',
        learnMore: 'Learn more',
        yourScore: 'Your score'
      }
    };
    var theLang = $('html').attr('lang');
    var that = this;
    DGS.Dictionary.getInstance().getTexts(dictionary, function () {
      that.dictionary = dictionary;
    }, theLang);
  },
  setSteps: function setSteps(theSteps) {
    this.steps = theSteps;
  },
  addPoints: function addPoints(points) {
    this.stepPoints[this.currentStepIndex] = points;
  },
  setDefaultPoints: function setDefaultPoints(points) {
    this.defaultPoints = points;
  }
};
decorate(store, {
  steps: observable,
  dictionary: observable,
  stepPoints: observable,
  defaultPoints: observable,
  currentStepIndex: observable,
  points: computed,
  nextStepIndex: computed,
  currentStep: computed,
  gotoStep: action,
  getDictionary: action,
  setSteps: action,
  addPoints: action,
  setDefaultPoints: action
});
export default store;